import React, { useState, useEffect } from 'react'
import { Panel, Form, Button, Message, Checkbox } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import CustomIconMessageInfo from '../CustomIconMessageInfo'
import { startLoading, doneLoading } from '../../utils/loading'
import InputForm from '../../components/forms/input/InputForm'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { useParams, useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import { updateDisclaim } from '../../redux/actions/disclaimProject'
import KycMessage from '../../components/message/kycMessage/KycMessage'

export default function DisclaimProjectWidget({
  schema: _schema,
  isCoworker,
  isDirector,
  ...props
}) {
  const { showCommandButton, isEditAll } = props
  const [section, setSection] = useState()
  const [isEdit, setIsEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [request, setRequest] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [schemaVerifyKyc, setSchemaVerifyKyc] = useState()
  const [isCheckConfirm, setIsCheckConfirm] = useState(false)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  useEffect(() => {
    setIsEdit(isEditAll)
  }, [isEditAll])

  const onSubmit = (data) => {
    console.log('onSubmit data', data)

    let request = {
      projectVersionId: projectId,
      value: isDirector ? '' : data[formSchema?.note?.name] || '',
    }
    console.log(request)
    setRequest(request)

    setIsShowConfirm(true)
  }

  const handleCallService = async () => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const response = await updateDisclaim(projectId, request)

      if (response.success) {
        //success jump to new page
        setIsError(false)
        setIsShowConfirm(false)
        doneLoading()
        setIsLoading(false)
        // return history.push(`${pathname.proposal.overview.overviewCoworker}/${projectId}`)
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const onConfirm = () => {
    console.log('onConfirm', request)
    handleCallService()
    setIsShowConfirm(false)
  }

  const onCancle = () => {
    console.log('onCancle')

    setRequest()
    setIsShowConfirm(false)
  }

  return (
    <Panel
      shaded
      header={isDirector ? 'อนุมัติสละสิทธิ์โครงการ' : 'สละสิทธิ์ข้อเสนอโครงการ'}
      eventKey={2}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      <Message
        showIcon
        type="info"
        description={
          'ภาคีผู้ขอรับทุนสามารถขอสละสิทธิ์โครงการ ช่วงที่โครงการยังไม่ถูกส่งไปขออนุมัติโครงการ '
        }
      />

      {formSchema.verifyKyc && <KycMessage schema={formSchema.verifyKyc} />}

      {formSchema?.note && (
        <InputForm
          schema={formSchema.note}
          rows={3}
          componentClass="textarea"
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
        />
      )}

      {isCoworker && (
        <>
          <br />
          <Checkbox
            onChange={(value, checked) => setIsCheckConfirm(checked)}
            checked={isCheckConfirm}
          >
            ข้าพเจ้ายืนยันที่จสละสิทธิ์
          </Checkbox>
        </>
      )}

      <hr />
      {isError && (
        <Message
          showIcon
          type="error"
          description={
            isDirector
              ? 'อนุมัติสละสิทธิ์โครงการ'
              : isCoworker
              ? 'สละสิทธิ์ข้อเสนอโครงการ' + `ไม่สำเร็จ`
              : formSchema.buttonText
          }
        />
      )}

      {!!formSchema.verifyKyc ? (
        <>
          {/* กรณีที่ยังที่ยืนยันตัวตน kyc */}
          <Button
            style={{ width: 'auto' }}
            color="rgb(45, 168, 136)"
            appearance="primary"
            disabled={true}
          >
            {'สละสิทธิ์ข้อเสนอโครงการ'}
          </Button>
        </>
      ) : (
        <>
          <Button
            style={{ width: 'auto' }}
            color="rgb(45, 168, 136)"
            appearance="primary"
            onClick={handleSubmit(onSubmit)}
            disabled={isCoworker ? !isCheckConfirm : false}
          >
            {isDirector
              ? 'อนุมัติสละสิทธิ์โครงการ'
              : isCoworker
              ? 'สละสิทธิ์ข้อเสนอโครงการ'
              : formSchema.buttonText}
          </Button>
        </>
      )}

      {/* <Button
        style={{ width: 'auto' }}
        color="rgb(45, 168, 136)"
        appearance="primary"
        onClick={handleSubmit(onSubmit)}
        disabled={isCoworker ? !isCheckConfirm : false}
      >
        {isDirector
          ? 'อนุมัติสละสิทธิ์โครงการ'
          : isCoworker
          ? 'สละสิทธิ์ข้อเสนอโครงการ'
          : formSchema.buttonText}
      </Button> */}

      <ConfirmWidget
        title={`ยืนยันการ${
          isDirector
            ? 'อนุมัติสละสิทธิ์โครงการ'
            : isCoworker
            ? 'สละสิทธิ์ข้อเสนอโครงการ'
            : formSchema.buttonText
        }`}
        show={isShowConfirm}
        detail={`${
          isDirector
            ? 'กรุณายืนยันการอนุมัติสละสิทธิ์โครงการ'
            : isCoworker
            ? 'ท่านยืนยันที่จะสละสิทธิการยื่นโครงการ'
            : formSchema.buttonText
        }`}
        onCancle={onCancle}
        onConfirm={onConfirm}
      />
    </Panel>
  )
}
